import DeclaracaoSaudeDetails, { TitularProps } from './DeclaracaoSaudeDetails';

export default DeclaracaoSaudeDetails;
export type { TitularProps };
